import React, { useCallback, useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CSpinner,
} from '@coreui/react-pro'
import {
  $accounts,
  $convertedCurrency,
  accountsMounted,
  convertCurrency,
  convertCurrencyMounted,
} from './model'
import { useStore } from 'effector-react'
import { awardedCashDepositMounted } from '../ParticipantsTable/model'
import { debounce } from 'lodash'

type Props = {
  userId: string
  participantId: string
  isVisible: boolean
  onClose: () => void
}

export const AwardedCashDepositModal: React.FC<Props> = ({
  userId,
  participantId,
  isVisible,
  onClose,
}) => {
  const accounts = useStore($accounts).filter(
    (item) =>
      item.status == 'active' && !item.isDemo && item.tariff !== 'bonus111',
  )
  const convertedCurrency = useStore($convertedCurrency)
  const convertedCurrencyLoading = useStore(convertCurrency.pending)

  const [formValues, setFormValues] = useState({
    accountId: '',
    amount: '',
  })

  useEffect(() => {
    if (isVisible) {
      accountsMounted({ id: userId })
    }
  }, [isVisible])

  const handleSubmit = () => {
    awardedCashDepositMounted({
      id: participantId,
      accountId: formValues.accountId,
      amount: formValues.amount,
    })
    setFormValues({
      accountId: '',
      amount: '',
    })
    onClose()
  }

  const debounceLoadData = useCallback(
    debounce(convertCurrencyMounted, 2000),
    [],
  )

  useEffect(() => {
    const accountCurrency = accounts.find(
      (item) => item.accountId == formValues.accountId,
    )?.currency

    if (accountCurrency && accountCurrency !== 'USD') {
      debounceLoadData({
        amount: formValues.amount,
        baseCurrency: 'USD',
        quoteCurrency: accountCurrency,
      })
    }
  }, [formValues.amount])

  return (
    <CModal
      visible={isVisible}
      onClose={() => {
        onClose()
        setFormValues({
          accountId: '',
          amount: '',
        })
      }}
      size={'lg'}
    >
      <CModalHeader>
        <CModalTitle>Awarded Cash Deposit</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CRow>
          <CCol xs={6}>
            <div className="mb-4">
              <CFormLabel className="fw-bold">Account</CFormLabel>
              <CFormSelect
                name="accountId"
                value={formValues.accountId}
                onChange={(e) => {
                  setFormValues((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }}
              >
                <option value="">Choose account</option>
                {accounts.map((item) => (
                  <option value={item.accountId}>{item.accountName}</option>
                ))}
              </CFormSelect>
            </div>
          </CCol>
          <CCol xs={3}>
            <div className="mb-4">
              <CFormLabel className="fw-bold">Account currency</CFormLabel>
              <div>
                {
                  accounts.find(
                    (item) => item.accountId == formValues.accountId,
                  )?.currency
                }
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol xs={6}>
            <div className="mb-4">
              <CFormLabel className="fw-bold">Amount USD</CFormLabel>
              <CFormInput
                name="amount"
                value={formValues.amount}
                onChange={(e) => {
                  setFormValues((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }}
              />
            </div>
          </CCol>
        </CRow>
        {convertedCurrency && (
          <CRow>
            <CCol xs={6}>
              <div className="mb-4">
                <CFormLabel className="fw-bold">Converted currency</CFormLabel>
                <div>
                  {convertedCurrencyLoading ? (
                    <CSpinner color="primary" />
                  ) : (
                    convertedCurrency.convertedAmount
                  )}
                </div>
              </div>
            </CCol>
          </CRow>
        )}
        <CModalFooter>
          <CButton
            color="secondary"
            onClick={() => {
              onClose()
            }}
          >
            Cancel
          </CButton>
          <CButton
            color="primary"
            className="px-4"
            onClick={() => {
              if (window.confirm('Are you sure?')) {
                handleSubmit()
              }
            }}
          >
            Ok
          </CButton>
        </CModalFooter>
      </CModalBody>
    </CModal>
  )
}
